import React from 'react';
import {MAIN_PAGE} from "../../pages/pageConstants/PageTypes";
import {MAIN_PATH} from "../../pages/pageConstants/PageRoutes";


const MainTemplate = {
	text: "Asosiy Oyna",
	accessKey: 1,
	path: MAIN_PATH,
	icon: "MainIcon",
	type: MAIN_PAGE,
};

export default MainTemplate;